import { Box, Flex, Text } from '@shared/components';

import FormImagesInput from '../form-images-input/form-images-input';

export interface PhotoSetRowProps {
  name: string;
  label: string;
  imageInputLabel: string;
  isReadonly?: boolean;
  uploadFiles?: (files: File[]) => Promise<string[]>;
  getFilesDownloadSignedUrls?: (fileNames: string[]) => Promise<string[]>;
  variant?: 'compact' | 'full';
}
export default function PhotoSetRow(props: PhotoSetRowProps) {
  const {
    name,
    label,
    imageInputLabel,
    isReadonly,
    uploadFiles,
    getFilesDownloadSignedUrls,
    variant = 'compact',
  } = props;

  return (
    <Flex
      sx={(theme) => ({
        gap: variant === 'compact' ? theme.spacing(2) : theme.spacing(6),
        justifyContent: 'space-between',
        flexDirection: 'column',
        [theme.breakpoints.up('desktop')]: {
          flexDirection: variant === 'compact' ? 'column' : 'row',
        },
      })}
    >
      <Box sx={{ width: variant === 'compact' ? '100%' : '320px' }}>
        <Text variant='body1Semibold'>
          {label}
          <Text component='span' color='error.main'>
            {' '}
            *
          </Text>
        </Text>
      </Box>
      <Flex
        sx={(theme) => ({
          flex: 1,
          flexDirection: 'column',
          gap: theme.spacing(2),
        })}
      >
        <FormImagesInput
          name={name}
          label={imageInputLabel}
          required
          disabled={isReadonly}
          uploadFiles={uploadFiles}
          getDownloadSignedUrls={getFilesDownloadSignedUrls}
        />
      </Flex>
    </Flex>
  );
}
